import { Overrides } from "@material-ui/core/styles/overrides";

export const overrides: Overrides = {};
